import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private isLoading = new BehaviorSubject<number>(0);
  public isLoading$ = this.isLoading.asObservable();

  constructor() { }

  public show() {
    this.isLoading.next(this.isLoading.value + 1);
  }

  public hide() {
    this.isLoading.next(this.isLoading.value - 1);
  }
}